export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.id.description", // "Código interno registro"
          label: "wkt.admin.qbuilder.model.vacation.id.text",   // "Código registro"
          field: "id"
        },
        {
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.employee-id.description", //"Código interno trabajador",
          label: "wkt.admin.qbuilder.model.vacation.employee-id.text",   //"Código trabajador",
          field: "employeeId"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.firstname.description", //"Nombre",
          label: "wkt.admin.qbuilder.model.vacation.firstname.text",   //"Nombre",
          field: "firstname"
        },
        {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.lastname.description", //"Apellidos",
          label: "wkt.admin.qbuilder.model.vacation.lastname.text",  //"Apellidos",
          field: "lastname"
        },
                {
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.id-number.description", //"Documento identificativo",
          label: "wkt.admin.qbuilder.model.vacation.id-number.text",  //"Documento ID",
          field: "idNumber"
        },
        {
          field: "username",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.username.description", //"Nombre de usuario",
          label: "wkt.admin.qbuilder.model.vacation.username.text",  //"username"
        },
        {
          field: "workplaceId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.workplace-id.description", //"Código del centro de trabajo",
          label: "wkt.admin.qbuilder.model.vacation.workplace-id.text",  //"Código centro trabajo"
        },
        {
          field: "workplaceName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.workplace-name.description", //"Nombre Centro de trabajo",
          label: "wkt.admin.qbuilder.model.vacation.workplace-name.text",  //"Centro trabajo"
        },
        {
          field: "departmentId",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.department-id.description", //"Código del departamento",
          label: "wkt.admin.qbuilder.model.vacation.department-id.text",  //"Código departamento"
        },
        {
          field: "departmentName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.department-name.description", //"Nombre Departamento",
          label: "wkt.admin.qbuilder.model.vacation.department-name.text",  //"Departamento"
        },
        {
          field: "recordType",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.record-type.description", //"Tipo de registro",
          label: "wkt.admin.qbuilder.model.vacation.record-type.text",  //"Tipo",
          formatter: 'formatChoice',
          choices: [ {  'key':'0', 'value':'wkt.admin.qbuilder.model.vacation.record-type.initial-balance' /*'Balance inicial'*/},
                     {  'key':'1', 'value':'wkt.admin.qbuilder.model.vacation.record-type.regularization' /*'Regularización'*/},
                     {  'key':'2', 'value':'wkt.admin.qbuilder.model.vacation.record-type.compensation' /*'Compensación'*/},
                     {  'key':'3', 'value':'wkt.admin.qbuilder.model.vacation.record-type.holidays' /*'Vacaciones'*/},
                     {  'key':'4', 'value':'wkt.admin.qbuilder.model.vacation.record-type.permission' /*'Permiso'*/},
                     {  'key':'5', 'value':'wkt.admin.qbuilder.model.vacation.record-type.holidays-by-hours' /*'Vacaciones por horas'*/},
                     {  'key':'6', 'value':'wkt.admin.qbuilder.model.vacation.record-type.permission-by-hours' /*'Permiso por horas'*/},
                     {  'key':'7', 'value':'wkt.admin.qbuilder.model.vacation.record-type.holidays' /*'Vacaciones'*/},
                     {  'key':'8', 'value':'wkt.admin.qbuilder.model.vacation.record-type.holidays-by-hours' /*'Vacaciones por horas'*/}
                    ]
        },
        {
          field: "paidAbsenceCategoryName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.absence_category.description", //"Categoría de ausencia",
          label: "wkt.admin.qbuilder.model.vacation.absence_category.text",  //"Categoría ausencia",
        },
        {
          field: "recordTitle",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.record-title.description", //"Descripción del registro",
          label: "wkt.admin.qbuilder.model.vacation.record-title.text",  //"Descripción"
        },
        {
          field: "fromDate",
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.vacation.from-date.description", //"Fecha inicio",
          label: "wkt.admin.qbuilder.model.vacation.from-date.text",  //"Fecha inicio",
          formatter: 'formatSimpleDate'
        },
        {
          field: "toDate",
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.vacation.to-date.description", //"Fecha fin",
          label: "wkt.admin.qbuilder.model.vacation.to-date.text",  //"Fecha fin",
          formatter: 'formatSimpleDate'
        },
        {
          field: "hoursBagName",
          type: "CHARACTER",
          desc: "wkt.admin.qbuilder.model.vacation.hours-bag-name.description", //"Nombre de la bolsa",
          label: "wkt.admin.qbuilder.model.vacation.hours-bag-name.text",  //"Bolsa",
        },
        {
          field: "hoursBagType",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.hours-bag-type.description", //"Tipo de la bolsa",
          label: "wkt.admin.qbuilder.model.vacation.hours-bag-type.text",  //"B. Tipo",
        },
        {
          field: "hoursBagUnit",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.hours-bag-unit.description",
          label: "wkt.admin.qbuilder.model.vacation.hours-bag-unit.text",
          formatter: 'formatChoice',
          choices: [
            { key: '0', value: 'wkt.admin.qbuilder.model.vacation.hours-bag-unit.days' },
            { key: '1', value: 'wkt.admin.qbuilder.model.vacation.hours-bag-unit.hours' }
          ]
        },
        {
          field: "hoursBagDelta",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.hours-bag-delta.description",
          label: "wkt.admin.qbuilder.model.vacation.hours-bag-delta.text",  //"B. diferencia",
        },
        {
          field: "hoursBagTotal",
          type: "NUMERIC",
          desc: "wkt.admin.qbuilder.model.vacation.hours-bag-total.description",
          label: "wkt.admin.qbuilder.model.vacation.hours-bag-total.text",  //"B. total",
        },
      ],
}
